import React from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { carecentreMuiTheme } from "../../theme";

/**
 * Wrap pilot pages (or the whole app) so MUI components use Carecentre tokens.
 */
const CcThemeProvider = ({
  theme = carecentreMuiTheme,
  children,
  ...props
}) => (
  <ThemeProvider theme={theme} {...props}>
    {children}
  </ThemeProvider>
);

export default CcThemeProvider;
